export const DASHBOAR_ACCESS_CONST = {
  ROLE: {
    VIEWER: 'viewer',
    EDITOR: 'editor',
  },
};
